module.exports = __webpack_public_path__ + "img/logo-pb.80b3fc35.png";